export enum IncomingRtpColumns {
	id = "Id",
	org = "Org",
	bank = "Bank",
	accountId = "Account",
	customer = "Customer",
	amount = "Amount",
	status = "Status",
	type = "Type",
	createdAt = "Created At",
	isMonetary = "Monetary",
}

export type AllowedIncomingRtpColumns =
	| IncomingRtpColumns.id
	| IncomingRtpColumns.org
	| IncomingRtpColumns.bank
	| IncomingRtpColumns.accountId
	| IncomingRtpColumns.customer
	| IncomingRtpColumns.amount
	| IncomingRtpColumns.status
	| IncomingRtpColumns.type
	| IncomingRtpColumns.isMonetary
	| IncomingRtpColumns.createdAt
